/* Swish storefront interactions. Reuses the Google & YouTube tag; never configures a second tag. */
(() => {
  'use strict';

  const shopify = window.Shopify;
  const testMode = new URLSearchParams(window.location.search).get('swish_analytics_test') === '1';
  const privatePath = /^\/(?:account|customer_authentication|checkout|checkouts|orders)(?:\/|$)/i;
  const preview = (shopify?.theme?.role && shopify.theme.role !== 'main') ||
    new URLSearchParams(window.location.search).has('preview_theme_id');
  if (window.__swishAnalyticsInitialized || window.top !== window || shopify?.designMode ||
      privatePath.test(window.location.pathname) ||
      !/^(?:www\.)?swishcourt\.com$/i.test(window.location.hostname) || (preview && !testMode)) return;
  window.__swishAnalyticsInitialized = true;

  const cleanLabel = (value) => String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  const heading = (element) => cleanLabel(element?.querySelector('h1, h2, h3')?.textContent);
  const ignored = '[data-swish-analytics-ignore], #shopify-pc__banner, #shopify-pc__prefs, ' +
    '[id^="pandectes"], [class*="pandectes"], [id^="ndn"], [class*="ndn"], ' +
    '[name="customer"], .account, .customer';

  // Fail closed until Shopify has loaded its authoritative, region-aware consent API.
  if (!shopify?.customerPrivacy && typeof shopify?.loadFeatures === 'function') {
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }

  function sectionName(control) {
    const explicit = control.closest('[data-swish-section]')?.getAttribute('data-swish-section');
    if (explicit) return cleanLabel(explicit);
    if (control.closest('header, .shopify-section-group-header-group')) return 'Header';
    if (control.closest('footer, .shopify-section-group-footer-group')) return 'Footer';
    if (control.closest('cart-drawer, #CartDrawer')) return 'Cart drawer';
    const section = control.closest('.shopify-section');
    // Some card grids use a separate rich-text section immediately above as their heading.
    // Do not mistake the first card's h3 for the heading of the entire grid.
    return cleanLabel(section?.querySelector('h1, h2')?.textContent) ||
      cleanLabel(section?.previousElementSibling?.querySelector('.rich-text__heading')?.textContent) || 'Page content';
  }

  function buttonName(control) {
    const card = control.closest('[data-swish-card], .multicolumn-list__item, .card-wrapper');
    const cardName = cleanLabel(card?.getAttribute('data-swish-card')) || heading(card);
    // Whole-card links must not collect their description, price, or changing court configuration.
    if (cardName && (control.contains(card?.querySelector('h1, h2, h3')) ||
        control.classList.contains('swish-preview-column__preview-cover-link'))) return cardName;
    const label = cleanLabel(control.getAttribute('data-swish-track') || control.getAttribute('aria-label') ||
      control.querySelector('.visually-hidden')?.textContent ||
      (control.matches('input') ? '' : control.textContent) || control.getAttribute('title'));
    return cardName && label && label !== cardName ? cleanLabel(`${cardName}: ${label}`) : (label || cardName);
  }

  function destination(control) {
    const href = control.getAttribute('href');
    if (!href) return 'on-page';
    if (/^mailto:/i.test(href)) return 'email';
    if (/^tel:/i.test(href)) return 'phone';
    if (href.startsWith('#')) return 'on-page';
    let url;
    try { url = new URL(href, window.location.href); } catch { return null; }
    if (!/^https?:$/.test(url.protocol) || privatePath.test(url.pathname) || url.pathname === '/search') return null;
    // Exclude query strings and fragments, including customer details and court design hashes.
    return (url.origin === window.location.origin ? url.pathname : `${url.origin}${url.pathname}`).slice(0, 100);
  }

  function track(event) {
    if (!event.isTrusted || (event.type === 'click' && event.button !== 0) ||
        (event.type === 'auxclick' && event.button !== 1)) return;
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const control = target?.closest('a[href], button, summary, [role="button"], [data-swish-track]');
    if (!control || control.closest(ignored) || control.disabled || control.getAttribute('aria-disabled') === 'true') return;
    const name = buttonName(control);
    const path = destination(control);
    if (!name || path === null) return;
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) {
      if (testMode) console.info('[Swish analytics] blocked by analytics consent');
      return;
    }
    if (typeof window.gtag !== 'function') {
      if (testMode) console.info('[Swish analytics] existing Google tag unavailable');
      return;
    }
    const parameters = {
      send_to: 'G-22234KNGMD',
      button_name: name,
      section_name: sectionName(control),
      destination_path: path,
      interaction_mode: testMode ? 'test' : 'production',
      page_location: `${window.location.origin}${window.location.pathname}`
    };
    if (testMode) parameters.debug_mode = true;
    window.gtag('event', 'ui_click', parameters);
    if (testMode) console.info('[Swish analytics] ui_click ' + JSON.stringify(parameters));
  }

  // Observe activation without delaying or modifying navigation, keyboard actions, or cart behavior.
  document.addEventListener('click', track, { capture: true, passive: true });
  document.addEventListener('auxclick', track, { capture: true, passive: true });
})();
